import { render, staticRenderFns } from "./EditText.vue?vue&type=template&id=62884c1c&scoped=true&"
import script from "./EditText.vue?vue&type=script&lang=js&"
export * from "./EditText.vue?vue&type=script&lang=js&"
import style0 from "./EditText.vue?vue&type=style&index=0&id=62884c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62884c1c",
  null
  
)

export default component.exports